






















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Utils } from '@/helper/utils';

@Component({})
class LogoutPage extends Vue {
  public logoPath: string;

  public created() {
    // this.logoPath = require("@/assets/"+Utils.AppEnvironmentName+"logo-1.png");
    this.logoPath = Utils.blobBaseUrl + "logo-1.png";
  }

  public redirectToLogin()
  {
          if(Utils.AppEnvironmentName == "Schomp"){
          setTimeout(() => {
          window.location.href = `${process.env.VUE_APP_ALYNK_V2_BASE_URL}/Account/Login`;
          }, 50);
          }
          else {
          window.location.href = '/app/account/Login';
          }
  }
}

export default LogoutPage;

